import script from "./NotificationBellMenuCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBellMenuCreator.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBellMenuCreator.vue?vue&type=style&index=0&id=045fb4eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045fb4eb"]])

export default __exports__